import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import { Inventory, Business } from "@mui/icons-material";

interface ColumnTypeStepProps {
  selectedType: "product" | "vendor" | null;
  onTypeSelect: (type: "product" | "vendor") => void;
}

export const ColumnTypeStep: React.FC<ColumnTypeStepProps> = ({
  selectedType,
  onTypeSelect,
}) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Choose Column Type
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Select whether you want to create a column for specific products or
        specific vendors.
      </Typography>

      <Stack direction="row" spacing={2}>
        <Card
          sx={{
            flex: 1,
            border: selectedType === "product" ? 2 : 1,
            borderColor:
              selectedType === "product" ? "primary.main" : "divider",
          }}
        >
          <CardActionArea onClick={() => onTypeSelect("product")}>
            <CardContent sx={{ textAlign: "center", py: 4 }}>
              <Inventory
                sx={{
                  fontSize: 48,
                  color:
                    selectedType === "product"
                      ? "primary.main"
                      : "text.secondary",
                  mb: 2,
                }}
              />
              <Typography variant="h6" sx={{ mb: 1 }}>
                Specific Products
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Show install presence of specific products that you're
                interested in (competitors or complementary products)
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>

        <Card
          sx={{
            flex: 1,
            border: selectedType === "vendor" ? 2 : 1,
            borderColor: selectedType === "vendor" ? "primary.main" : "divider",
          }}
        >
          <CardActionArea onClick={() => onTypeSelect("vendor")}>
            <CardContent sx={{ textAlign: "center", py: 4 }}>
              <Business
                sx={{
                  fontSize: 48,
                  color:
                    selectedType === "vendor"
                      ? "primary.main"
                      : "text.secondary",
                  mb: 2,
                }}
              />
              <Typography variant="h6" sx={{ mb: 1 }}>
                Specific Vendors
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Customize competitive landscape analysis and understand
                relationships between accounts and vendors
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Stack>
    </Box>
  );
};
